import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { useMapValidator } from './useMapValidator.ts';
import { usePlayerValidators } from './usePlayerValidators.ts';
import { useCurrentStateValidator } from './useCurrentStateValidator.ts';
import { MechanicValidatorSettlement } from '@colonist/game-mechanic-validators';
export const useMechanicValidatorSettlement = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const currentStateValidator = useCurrentStateValidator();
    const mechanicSettlementState = useGameStore((state)=>state.gameState.mechanicSettlementState);
    return useMemo(()=>{
        if (!mechanicSettlementState) return undefined;
        return new MechanicValidatorSettlement(playerValidators, mapValidator, currentStateValidator, mechanicSettlementState);
    }, [
        playerValidators,
        mapValidator,
        currentStateValidator,
        mechanicSettlementState
    ]);
};
